import FormElementMixin from '@/mixins/form-element-mixin';

export default {
    name: 'QInput',
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: ''
        },
        value: {
            type: [String, Number],
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        iconRight: {
            type: String,
            default: ''
        },
        hasIconRightAction: {
            type: Boolean,
            default: false
        },
        hasPopover: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: 'none'
        },
        placeholder: {
            type: String,
            default: ''
        },
        loadedFunction: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'md'
        },
        classes: {
            type: String,
            default: ''
        },
        condensed: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false,
            statusType: this.status
        };
    },
    mounted() {
        this.$emit('input', this.value);

        // NOTES: JDN - 07/12/2019
        // 1. Moving autoNumeric init into the Vue Input Component.
        // 2. If there are numericOptions passed in, we init autoNumeric.
        // 3. Currently this is calling the window function since we load
        //    autoNumeric in our v2 code. Eventually, we should call autoNumeric
        //    using node_modules and within Vue. However, we don't want to
        //    call it twice right NOW within pages already using it in v2.
        if (this.loadedFunction) {
            window[this.loadedFunction]();
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: event => this.$emit('input', event.target.value)
            };
        },
        rootClasses() {
            return [
                this.iconPosition,
                this.size,
                'is-' + this.type,
                {
                    'is-loading': this.loading,
                    'is-clearfix': !this.hasMessage,
                    'is-popover-active': this.focused && this.hasPopover,
                    'has-icon-right-action':
                        this.hasIconRightAction && this.iconRight,
                    'is-condensed': this.condensed
                }
            ];
        },
        inputClasses() {
            return ['input-' + this.size, this.statusType, this.classes];
        },
        hasIconRight() {
            return this.loading || this.iconRight || this.statusType;
        },
        // if icon is positioned left, right or both - this class is needed for padding on the input
        iconPosition() {
            if (this.icon && this.hasIconRight) {
                return 'has-icons-left has-icons-right';
            } else if (!this.icon && this.hasIconRight) {
                return 'has-icons-right';
            } else if (this.icon) {
                return 'has-icons-left';
            }
        }
    },
    methods: {
        onClickClose() {
            this.value = '';
            this.statusType = '';

            this.$emit('onEmitStatus', this.statusType);
            this.$emit('input', this.value);
            this.$emit('onEmitValue');
            this.focused = true;
            this.$forceUpdate();
        },
        onBlurInput() {
            this.focused = false;
        },
        onClickRightIcon() {
            // Handle password toggle of eye icons.
            if (
                this.iconRight === 'eye-outline' ||
                this.iconRight === 'eye-slash-outline'
            ) {
                this.type = this.type === 'text' ? 'password' : 'text';
                this.$emit('onClickRightIcon', this.type);
            } else {
                this.$emit('onClickRightIcon');
            }
        }
    }
};
